<template>
    <div class="relativeContainer">
        <div class="social"><a href="https://www.facebook.com/croustillance/" target="_blank" border="0"><img src="/img/facebook.svg" width="35px" class="socialSpacer"></a>
          <a href="https://www.instagram.com/croustillance.traiteur/" target="_blank" border="0"><img src="/img/instagram.svg" width="35px" class="socialSpacer"></a>
          <a href="https://fr.linkedin.com/company/croustillance" target="_blank" border="0"><img src="/img/linkedin.svg" width="35px" class="socialSpacer"></a>
        </div>
        <div class="logoTop" v-if="displayLogo"><img src="/img/logo-croustillance.svg" width="320px"></div>
    </div>
</template>

<script>
    export default {
        name: "headerPage",
      props: {
        displayLogo: {Boolean, default: true},
      }
    }
</script>

<style>
    .relativeContainer {
    position: relative;
}

.social {
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 30;
}
.socialSpacer {
  margin-right:15px;
}
.logoTop {
    position:absolute;
    top: 0;
    z-index: 5;
    background: #ffffffb3;
    margin: auto;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 20px;
}

</style>